import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initializeApp } from 'firebase/app';
import { getAuth, SAMLAuthProvider, signInWithPopup } from 'firebase/auth';
import { env } from '../../../env';
import { AsyncThunkConfig } from '../../async-thunk-config';
import { AdminConsoleState, AdminConsoleUser } from './admin-console-types';
import { CustomerServiceGenericError } from './customer-service/customer-service-types';

const allowedGroup = env.adminConsoleMemberOfGroup;

const initialState: AdminConsoleState = {
  user: null,
};

const provider = new SAMLAuthProvider(env.firebaseProvider);
export const adminConsoleLogin = createAsyncThunk<
  void,
  void,
  AsyncThunkConfig<CustomerServiceGenericError>
>('admin-console-login', async (_, thunkApi) => {
  try {
    const config = {
      apiKey: env.firebaseApiKey,
      authDomain: env.firebaseAuthDomain,
    };

    const auth = getAuth(initializeApp(config));

    const userCred = await signInWithPopup(auth, provider);
    const credential = await userCred?.user?.getIdTokenResult();
    const attributes = (credential?.claims?.firebase as any)
      ?.sign_in_attributes;
    const group = attributes?.memberOf;
    if (userCred?.user && allowedGroup === group) {
      thunkApi.dispatch(
        adminConsoleSliceActions.setUser({
          token: credential.token,
          name: attributes?.NOME,
          surname: attributes?.COGNOME,
        })
      );
    }
    return null;
  } catch (error) {
    console.error('Login error:', error);
    return thunkApi.rejectWithValue('GENERIC_ERROR');
  }
});

const adminConsoleSlice = createSlice({
  name: 'features/adminConsole/common',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<AdminConsoleUser>) {
      state.user = action.payload;
    },
  },
});

export const adminConsoleSliceActions = adminConsoleSlice.actions;

export default adminConsoleSlice.reducer;
